import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import { immerable, produce } from 'immer';
import { Map } from 'immutable';

import { SubscriptionForDepotItemEntity } from './available-subscription-item.entity';

export interface IAvailableConnectorListExtra
	extends IListColumnConfig<SubscriptionForDepotItemEntity> {
	isFixed?: boolean;
	isSelectable?: boolean;
	isSearchable?: boolean;
	isInGroup?: boolean;
	isVisible?: boolean;
	canBeHidden?: boolean;
	canBeReordered?: boolean;
	canBeChosen?: boolean;
	format?: string;
	visibleIndex?: number;
	visible?: boolean;
	hasHeaderFilter?: boolean;
}

interface IConnectorListEntity
	extends IListAttrs<SubscriptionForDepotItemEntity> {
	availableColumns: Map<string, IAvailableConnectorListExtra>;
}

const entityDefaults: IConnectorListEntity = {
	elements: Map(),
	availableColumns: Map(),
};

export class SubscriptionListEntity
	implements
		IConnectorListEntity,
		IListOperations<SubscriptionListEntity, SubscriptionForDepotItemEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;

	public static build(
		availableCols: Array<IAvailableConnectorListExtra>
	): SubscriptionListEntity {
		const inst = new SubscriptionListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, IAvailableConnectorListExtra]>());
		inst.availableColumns = Map(cols);
		return inst;
	}

	private constructor() {}

	public getAvailableColumns(): Map<
		string,
		IListColumnConfig<SubscriptionForDepotItemEntity>
	> {
		return this.availableColumns;
	}

	public setElements(
		elems: Map<string, SubscriptionForDepotItemEntity>
	): SubscriptionListEntity {
		return produce(this, (draft: SubscriptionListEntity) => {
			draft.elements = elems;
		});
	}

	// public extractUniqTags(...startValues: Array<string>): Set<string> {
	// 	return this.elements.reduce((acc, connectorItem) => {
	// 		if (!connectorItem.tags) {
	// 			return acc;
	// 		}
	// 		return Set([
	// 			...acc.toArray(),
	// 			...connectorItem.tags
	// 				.toList()
	// 				.toArray()
	// 				.map((l) => l.label),
	// 		]);
	// 	}, Set<string>(startValues));
	// }
}
